import container from './container';

export { handleImageUpload } from './container';

export default container;
